import { Component } from "@angular/core";
import { NgClass, NgForOf, NgIf } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {GenerateFormComponent} from "./generate-form/generate-form.component";
import {StandardFormComponent} from "./standard-form/standard-form.component";
import {CustomFormComponent} from "./custom-form/custom-form.component";

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  standalone: true,
  imports: [
    NgForOf, NgIf, ReactiveFormsModule, FormsModule,
    NgClass, GenerateFormComponent, StandardFormComponent, CustomFormComponent

  ],
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent {
  activeSection: 'generate' | 'standard' | 'custom' = 'standard';
  setActive(section: 'generate' | 'standard' | 'custom') {
    this.activeSection = section;
  }
}
